import { createFileRoute, Outlet } from '@tanstack/react-router'
import { guardAuthed, RouteError } from '@pa/staff'

/**
 * Every clinic page: the guards (Frontend §5.3 rows 1–3). A confirmed impersonation (`/v1/me` answered with it)
 * names its clinic, whose routes then get `X-Impersonation-Id` (Frontend §6.4 steps 3–4).
 */
export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context, location }) => {
    const { me } = await guardAuthed(context, 'clinic', location.href)
    if (me.impersonation) context.impersonation.confirm(me.impersonation.clinic.id)
    return { me }
  },
  component: Outlet,
  errorComponent: RouteError,
})
